import { otto } from "../../../exports/nexus.js";

const { assignments } = otto.onex;
const $brand = Symbol("customAssignments");

const thisOrData = (data: unknown): App.Onex | undefined =>
  !!data && typeof data === "object" && $brand in data
    ? (data[$brand] as App.Onex)
    : assignments.get();

/**
 *
 *
 *
 */
export type OnexThisObject = { [$brand]: App.Onex };

/**
 *
 *
 *
 *
 */
export function customAssignments(data: App.Onex): OnexThisObject {
  return { [$brand]: data };
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function isOnexVariant(
  this: unknown | void | OnexThisObject,
  onexId: string,
  variantId: string,
): boolean {
  const data = thisOrData(this);
  if (!data) return false;

  const variant = data?.[onexId];
  return !!variant && variant === variantId;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function mapOnexVariant<OnexMap extends Record<string, unknown>, D = undefined>(
  this: unknown | void | OnexThisObject,
  onexId: string,
  variantMap: OnexMap,
  ...a: undefined extends D ? [] : [defaultValue: D]
): OnexMap[keyof OnexMap] | D {
  const data = thisOrData(this);
  if (!data) return a[0] as D;

  const variant = data[onexId];
  if (!variant || variantMap[variant] === undefined) return a[0] as D;
  return variantMap[variant] as OnexMap[keyof OnexMap];
}

/**
 *
 */
export interface WithOnex {
  /**
 *
 *
 *
 */
  isVariant: (variantId: string) => boolean;

  /**
 *
 *
 *
 *
 */
  mapVariant: <OnexMap extends Record<string, unknown>, D = undefined>(
    variantMap: OnexMap,
    ...a: undefined extends D ? [] : [defaultValue: D]
  ) => OnexMap[keyof OnexMap] | D;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function withOnex(this: unknown | void | OnexThisObject, onexId: string): WithOnex {
  const isVariant: WithOnex["isVariant"] = (variantId) =>
    isOnexVariant.call(this, onexId, variantId);

  const mapVariant: WithOnex["mapVariant"] = (variantMap, ...a) =>
    mapOnexVariant.apply(this, [onexId, variantMap, ...a] as never) as never;

  return Object.assign({ isVariant, mapVariant }, { isGroup: isVariant, mapGroup: mapVariant });
}
